var PRIMEServicesUKPDSOM2 = angular.module("PRIMEServicesUKPDSOM2", ["ngResource"]);






PRIMEServicesUKPDSOM2.factory("CohortUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/cohorts/:cohortId", {cohortId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesUKPDSOM2.factory("DefaultCohortsUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/cohorts/defaults/:cohortId", {cohortId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true}
		});
	}
]);

PRIMEServicesUKPDSOM2.factory("DefaultCohortUKPDSOM2", [function() {
	return {
		name:"New UKPDS OM2 cohort",
		note:"",
		version:1,
		project:null,
		references:"Hayes et al. UKPDS outcomes model 2: a new version of a model to simulate lifetime health outcomes of patients with type 2 diabetes mellitus using data from the 30 year United Kingdom Prospective Diabetes Study: UKPDS 82. Diabetologia. 2013;56(9):1925-33. ",
		male:{
			proportion:54.1
		},
		isCollegeEducationOrAbove:{
			proportion:25.97
		},
		smoker:{
			proportion:18.4
		},
		age:{
			mean:26.7,
			sd:7.1
		},
		white:{
			proportion:100.0,
		},
		black:{
			proportion:0.0,
		},
		hispanic:{
			proportion:0.0,
		},
		southEastAsian:{
			proportion:0.0,
		},
		indian:{
			proportion:0.0,
		},
		otherrace:{
			proportion:0.0,
		},
		durationOfDiabetesAtBaseline:{
			mean:1,
			sd:0.3
		},
		hbA1c:{
			mean:8.2,
			sd:1.5
		},
		sBP:{
			mean:143,
			sd:20
		},
		tChol:{
			mean:5.0,
			sd:1.6
		},
		lDL:{
			mean:3.0,
			sd:0.6
		},
		hDL:{
			mean:1.19,
			sd:0.30
		},
		bMI:{
			mean:30.5,
			sd:6
		},
		eGFR:{
			mean:77.5,
			sd:15
		},
		wBC:{
			mean:6.8,
			sd:1.8
		},
		heartRate:{
			mean:72,
			sd:12
		},
		haem:{
			mean:14.5,
			sd:13
		},
		atfib:{
			proportion:0
		},
		mmalb:{
			proportion:0
		},
		pvd:{
			proportion:0
		},
		myocardialInfarctAtBaseline:{
			proportion:0
		},
		strokeAtBaseline:{
			proportion:0
		},
		ischemicHeartDiseaseAtBaseline:{
			proportion:0
		},
		heartFailureAtBaseline:{
			proportion:0
		},
		ulcerAtBaseline:{
			proportion:0
		},
		amputationAtBaseline:{
			proportion:0
		},
		blindnessAtBaseline:{
			proportion:0
		},
		renalFailureAtBaseline:{
			proportion:0
		},
		neuropathyAtBaseline:{
			proportion:0
		}
	}
}])





PRIMEServicesUKPDSOM2.factory("TreatmentUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/treatments/:treatmentId", {treatmentId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesUKPDSOM2.factory("DefaultTreatmentUKPDSOM2", function() {
		return {
			name : "New UKPDS OM2 treatment",
			notes : "",
			version:1,
			project:null,
			references:"",
			depth : 0,
			treatmentEffects : {
				HBA1C : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				SBP : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				BMI : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				HDL : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				LDL : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				EGFR : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				WBC : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				HAEM : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				}
			},
			amputationHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			blindnessHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			hFHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			iHDHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			mIHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			renalFailureHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			strokeHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			ulcerHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			deathWithNoHistoryOrEventsHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			deathInFirstYearOfEventsHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			deathInYearsWithHistoryButNotEventsHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			deathInSubsequentYearsOfEventsHR : {
				distribution : "LOGNORMAL",
				mean : 1.0,
				sd : 0.0,
				se : 0.0
			},
			hbA1cProgression : "UKPDS_1",
			sBPProgression : "UKPDS_1",
			lDLProgression : "FLAT",
			hDLProgression : "FLAT",
			bMIProgression : "FLAT",
			eGFRProgression : "FLAT",
			wBCProgression : "FLAT",
			hRProgression : "FLAT",
			hBProgression : "FLAT",
			hbA1cAnnualChange : 0,
			sBPAnnualChange : 0,
			bMIAnnualChange : 0,
			hDLAnnualChange : 0,
			lDLAnnualChange : 0,
			eGFRAnnualChange : 0,
			wBCAnnualChange : 0,
			hRAnnualChange : 0,
			hBAnnualChange : 0,
			timeOnTreatment: 0,
			annualCostYear1 : 100,
			annualCostYear2 : 100,
			switchCondition: null,
			annualQoLDecrementYear1 : 0,
			annualQoLDecrementYear2 : 0,
			hypoglycemiaOption : 1,
			annualNonSevereDaytimeHypoRate : {
				distribution : "NORMAL",
				mean : 0.0,
				sd : 0.0,
				se : 0.0
			},
			annualNonSevereNocturnalHypoRate : {
				distribution : "NORMAL",
				mean : 0.0,
				sd : 0.0,
				se : 0.0
			},
			annualSevereHypoRate : {
				distribution : "NORMAL",
				mean : 0.0,
				sd : 0.0,
				se : 0.0
			}
		}
	}
);

PRIMEServicesUKPDSOM2.factory("DefaultTreatmentSwitchUKPDSOM2", function() {
		return {
			"subsequentTreatment": {
				depth : 1,
				treatmentEffects : {
					HBA1C : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					SBP : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					BMI : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					HDL : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					LDL : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					EGFR : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					WBC : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					},
					HAEM : {
						distribution : "NORMAL",
						mean : 0.0,
						sd : 0.0,
						se : 0.0
					}
				},
				amputationHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				blindnessHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				hFHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				iHDHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				mIHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				renalFailureHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				strokeHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				ulcerHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				deathWithNoHistoryOrEventsHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				deathInFirstYearOfEventsHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				deathInYearsWithHistoryButNotEventsHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				deathInSubsequentYearsOfEventsHR : {
					distribution : "LOGNORMAL",
					mean : 1.0,
					sd : 0.0,
					se : 0.0
				},
				hbA1cProgression : "UKPDS_1",
				sBPProgression : "UKPDS_1",
				lDLProgression : "FLAT",
				hDLProgression : "FLAT",
				bMIProgression : "FLAT",
				eGFRProgression : "FLAT",
				wBCProgression : "FLAT",
				hRProgression : "FLAT",
				hBProgression : "FLAT",
				hbA1cAnnualChange : 0,
				sBPAnnualChange : 0,
				bMIAnnualChange : 0,
				hDLAnnualChange : 0,
				lDLAnnualChange : 0,
				eGFRAnnualChange : 0,
				wBCAnnualChange : 0,
				hRAnnualChange : 0,
				hBAnnualChange : 0,
				timeOnTreatment: 0,
				annualCostYear1 : 100,
				annualCostYear2 : 100,
				switchCondition: null,
				annualQoLDecrementYear1 : 0,
				annualQoLDecrementYear2 : 0,
				hypoglycemiaOption : 1,
				annualNonSevereDaytimeHypoRate : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				annualNonSevereNocturnalHypoRate : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				},
				annualSevereHypoRate : {
					distribution : "NORMAL",
					mean : 0.0,
					sd : 0.0,
					se : 0.0
				}
			},
			switchType:"DURATION",
			switchThreshold: 0,
			switchAboveThreshold: false,
			switchProperty: "BMI",
			annualProbabilityOfSwitch: null,
			yearsUntilSwitch: 5,
			discontinuationActive: false,
			annualProbabilityOfDiscontinuation: 0
			
		}
	}
);

PRIMEServicesUKPDSOM2.factory("SwitchRiskFactorsUKPDSOM2", function() {
		return [
			{ id:"BMI", name: "Body mass index (kg)" },
			{ id:"EGFR", name: "Estimated glomerular filtration rate (m/min/1.73m2)" }, 
			{ id:"HAEM", name: "Hemoglobin (g/dL)" }, 
			{ id:"HBA1C", name: "HbA1c (%)" },
			{ id:"HDL", name: "HDL cholesterol (mmol/L)" },
			{ id:"LDL", name: "LDL cholesterol (mmol/L)" },
			{ id:"SBP", name: "Systolic blood pressure (mmHg)" },
			{ id:"WBC", name: "White blood cell count (1,000,000 cells/L)" }
		];
	}
);





PRIMEServicesUKPDSOM2.factory("CostUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/costs/:costId", {costId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesUKPDSOM2.factory("DefaultCostUKPDSOM2", [function() {
	return {
		name:"New UKPDS OM2 cost",
		note:"",
		references:"• Yeaw J, Halinan S, Hines D, Delozier A, Perez M, Boye M, Boye KS, Blanchette CM. Direct medical costs for complications among children and adults with diabetes in the US commercial payer setting. Appl Health Econ Health Policy. 2014;12(2):219-30.\n\
• Inflation index 517.228 (April 2018): https://www.bls.gov/news.release/archives/cpi_05102018.pdf (Table 1 CPI-U for Medical care services)\n\
• Inflation index 400.258 (2011 mean): https://www.bls.gov/news.release/archives/cpi_01192012.pdf (Table 1A CPI-U for Medical Care)",
		version:1,
		project:null,
		currency:"USD",
		year:2011,
		amputation : {
			eventCost : {
				mean : (((1924 * 707 / (707 + 128 + 383)) + (2281 * 128 / (707 + 128 + 383)) + (12379 * 383 / (707 + 128 + 383)))).toFixed(2),
				sD : 0
			},
			stateCost : {
				mean : (((356 * 707 / (707 + 128 + 383)) + (506 * 128 / (707 + 128 + 383)) + (3817 * 383 / (707 + 128 + 383)))).toFixed(2),
				sD : 0
			}
		},
		ulcer : {
			eventCost : {
				mean : 4461,
				sD : 0
			},
			stateCost : {
				mean : 2199,
				sD : 0
			}
		},
		ischemicHeartDisease : {
			eventCost : {
				mean : 2686,
				sD : 0
			},
			stateCost : {
				mean : 431,
				sD : 0
			}
		},
		heartFailure : {
			eventCost : {
				mean : 9440,
				sD : 0
			},
			stateCost : {
				mean : 4687,
				sD : 0
			}
		},
		myocardialInfarct : {
			eventCost : {
				mean : 12747,
				sD : 0
			},
			stateCost : {
				mean : 1434,
				sD : 0
			}
		},
		stroke : {
			eventCost : {
				mean : 5502,
				sD : 0
			},
			stateCost : {
				mean : 764,
				sD : 0
			}
		},
		blindness : {
			eventCost : {
				mean : 847,
				sD : 0
			},
			stateCost : {
				mean : 220,
				sD : 0
			}
		},
		renalFailure : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		severeHypoglycemia : {
			eventCost : {
				mean : 241,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereDaytimeHypoglycemia : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereNocturnalHypoglycemia : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : null,
				sD : null
			}
		},
		indirectCosts: {
			meanAgeAtWorkforceEntry: 0.0,
			meanAgeAtRetirement: 0.0,
			meanSalaryMale: {
				mean: 0.0,
				sD: 0.0
			},
			meanSalaryFemale: {
				mean: 0.0,
				sD: 0.0
			},
			percentageEmployed: 0.0,
			workingDaysPerYear: 0,
			amputation: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ulcer: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ischemicHeartDisease: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			heartFailure: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			myocardialInfarct: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			neuropathy: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			stroke: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			blindness: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ckdStage1 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage2 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage3 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage4 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			renalFailure : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			}
		},
		indirectCostsActive : false
	}
}])






PRIMEServicesUKPDSOM2.factory("UtilityUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/utilities/:utilityId", {utilityId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesUKPDSOM2.factory("DefaultUtilityUKPDSOM2", [function() {
	return {
		name:"New UKPDS OM2 utility",
		note:"",
		references: "Beaudet A, Clegg J, Thuresson PO, Lloyd A, McEwan P. Review of utility values for economic modeling in type 2 diabetes. Value Health. 2014;17(4):462-70.",
		version:1,
		project:null,
		qoLApproach: "ADDITIVE",
		baselineQoL : {
			0 : {
				mean : 0.785,
				sD : 0.0
			}
		},
		amputation : {
			eventOrOnsetDisutility : {
				mean : -0.28,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		ulcer : {
			eventOrOnsetDisutility : {
				mean : -0.170,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		ischemicHeartDisease : {
			eventOrOnsetDisutility : {
				mean : -0.09,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		heartFailure : {
			eventOrOnsetDisutility : {
				mean : -0.108,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		myocardialInfarct : {
			eventOrOnsetDisutility : {
				mean : -0.055,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		stroke : {
			eventOrOnsetDisutility : {
				mean : -0.164,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		blindness : {
			eventOrOnsetDisutility : {
				mean : -0.074,
				sD : 0
			},
			stateDisutility : {
				mean : -0.074,
				sD : 0
			}
		},
		renalFailure : {
			eventOrOnsetDisutility : {
				mean : 0.0,
				sD : 0
			},
			stateDisutility : {
				mean : 0.00,
				sD : 0
			}
		},
		severeHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.028,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereDaytimeHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.004,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereNocturnalHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.008,
				sD : 0
			},
			stateDisutility : null
		}
	}
}])






PRIMEServicesUKPDSOM2.factory("CountryUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/countries/:countryId", {countryId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);


PRIMEServicesUKPDSOM2.factory("DefaultCountryUKPDSOM2", function() {
		return {
			name : "New UKPDS OM2 country",
			note : "",
			version:1,
			project:null,
			costDiscountRate:3,
			effectDiscountRate:3,
			hbA1cProgression:"FLAT",
			hbA1cAnnualChange:0,
			sBPProgression:"FLAT",
			sBPAnnualChange:0,
			bMIProgression:"FLAT",
			bMIAnnualChange:0,
			hDLProgression:"FLAT",
			hDLAnnualChange:0,
			lDLProgression:"FLAT",
			lDLAnnualChange:0,
			eGFRProgression:"FLAT", // FLAT or ZOPPINI
			eGFRAnnualChange:0,
			wBCProgression:"FLAT",
			wBCAnnualChange:0,
			hRProgression:"FLAT",
			hRAnnualChange:0,
			hBProgression:"FLAT",
			hBAnnualChange:0,
			mortalityOption: "LIFE_TABLES", // LIFE_TABLES, UKPDS_OM2, or HYBRID
			renalFailureModel:"UKPDS", // EGFR or UKPDS
			lifetable:"Japan-2016"
		}
	}
);






PRIMEServicesUKPDSOM2.factory("LifeTableUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/countries/life-tables", {}, {
			get: {method:"GET"}
		});
	}
]);


PRIMEServicesUKPDSOM2.factory("SimulationServiceUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/simulations/:simulationId", {simulationId:"@_id"}, {
      get:    { method:"GET", params: { fullElements: true } },
      // keep legacy array endpoint (if still used somewhere)
      query:  { method:"GET", isArray:true,  params: { summary: true } },
      // NEW: paged summaries → returns the { items, page, pageSize, total, totalPages } envelope
      queryPaged: {
        method: "GET",
        isArray: false,
        params: { summary: true },
        // $resource will send ?page=&pageSize=&search= we pass from controller
      },
      clone:  { method:"GET", params: { fullElements: true, omitResults: true } },
      rerun:  { method:"GET", params: { rerun: true } },
      save:   { method:"POST" },
      delete: { method:"DELETE" },
      update: { method:"PUT" }
    });
	}
]);


PRIMEServicesUKPDSOM2.factory("QueueServiceUKPDSOM2", ["$resource",
	function($resource) {
		return $resource("api/ukpdsom2/simulations/in-queue", {}, {
			get: {method:"GET"},
		});
	}
]);



PRIMEServicesUKPDSOM2.factory("ICERCalculatorUKPDSOM2", 
	function ICERCalculatorUKPDSOM2() {
		
		function icer(simulation, discounted) {
			if (simulation === undefined) {
				return '';
			}

			if ((simulation.arms['0'] === undefined || simulation.arms['0']) === null && (simulation.arms['1'] === undefined || simulation.arms['1'] === null)) {
				return 'Pending';
			}
			
			if (simulation.arms['0'] === undefined || simulation.arms['0'] === null || simulation.arms['1'] === undefined || simulation.arms['1'] === null) {
				return '–';
			}
			
			var comparatorCost = discounted ? simulation.arms["0"].cumulativeDiscountedCost[simulation.arms["0"].cumulativeDiscountedCost.length - 1] : simulation.arms["0"].cumulativeUndiscountedCost[simulation.arms["0"].cumulativeUndiscountedCost.length - 1] ,
				interventionCost = discounted ? simulation.arms["1"].cumulativeDiscountedCost[simulation.arms["0"].cumulativeDiscountedCost.length - 1] : simulation.arms["1"].cumulativeUndiscountedCost[simulation.arms["0"].cumulativeUndiscountedCost.length - 1] ,
				comparatorQALE = discounted ? simulation.arms["0"].cumulativeDiscountedQALE[simulation.arms["0"].cumulativeDiscountedQALE.length - 1] : simulation.arms["0"].cumulativeUndiscountedQALE[simulation.arms["0"].cumulativeUndiscountedQALE.length - 1],
				interventionQALE = discounted ? simulation.arms["1"].cumulativeDiscountedQALE[simulation.arms["0"].cumulativeDiscountedQALE.length - 1] : simulation.arms["1"].cumulativeUndiscountedQALE[simulation.arms["0"].cumulativeUndiscountedQALE.length - 1];
	
			var icer = "";

			if (interventionCost < comparatorCost && interventionQALE > comparatorQALE) {
				icer = "Dominant";
			}

			if (interventionCost > comparatorCost && interventionQALE < comparatorQALE) {
				icer = "Dominated";
			}

			if (interventionCost == comparatorCost) {
				icer = "Same cost";
				if (interventionQALE < comparatorQALE) {
					icer += ", less effective";
				} else if (interventionQALE > comparatorQALE) {
					icer += ", more effective";
				} else {
					icer += ", same effectiveness";
				}
			}

			if (interventionQALE == comparatorQALE) {
				icer = "Same effectiveness";
				if (interventionCost < comparatorCost) {
					icer += ", less costly";
				} else if (interventionCost > comparatorCost) {
					icer += ", more costly";
				} else {
					icer += ", same cost";
				}
			}

			if (icer === "") {
				icer = addCommas(((interventionCost - comparatorCost) / (interventionQALE - comparatorQALE)).toFixed(0));
			}

			return simulation.progress == "Complete" ? icer : "Pending";
		}
		
		return {
			icer : icer
		}
	}
);